<div class="content">

  <!--
    62px, taller than the list's (40px) and the side panel's (48px) headers so its size reads as meant
    (Johanna, 2026-11-02, taller again after rounds 3 and 4), and off-white, over the white date row that holds the arrows (after the
    prototype); the week number is its own badge. The month menu is the small field, so its popover opens
    just under "November 2026".
  -->
  <div class="header h-[62px] shrink-0 gap-2 border-b border-gray-200 bg-offwhite px-8">
    @if (['month', 'year'] | includesBy : calendarType.value) {
      <app-dropdown-month-year-input
        [control]="date"
        appearance="sapphire-inline"
        size="s"
        [title]="(captionDate | dateFormat : 'monthName') + ' ' + (captionDate | dateFormat : 'year')"
        />
    }

    @if (['week', 'workWeek', 'day'] | includesBy : calendarType.value) {
      <app-dropdown-date-input
        [control]="date"
        appearance="sapphire-inline"
        size="s"
        dateFormat="month"
        />
    }

    <span class="shrink-0 whitespace-nowrap rounded-full bg-gray-100 px-4 text-sm font-medium leading-10 text-gray-700">
      Week {{ weekBadgeDate | dateFormat : 'weekNumber' }}
    </span>

    <div class="header-divider"></div>
    <div class="header-right">
      <!-- Today as in panel 4's month: a 12px medium Blue/600 link (Johanna, 2026-11-01). -->
      <button
        type="button"
        class="shrink-0 rounded-sm px-3 text-sm font-medium leading-12 text-blue-600 hover:bg-blue-50"
        (click)="setToday()"
      >Today</button>

      <app-dropdown-input
        [inputFormControl]="calendarType"
        [options]="calendarTypes"
        appearance="sapphire-outline"
        size="s"
        placement="bottomLeft"
      />
    </div>
  </div>

  <stch-calendar-date-nav [view]="calendarType.value" [date]="date.value" (previous)="prevDate()" (next)="nextDate()" />

  <div class="full-height" [@slideAnimation]="dateRangeCalendarEventsListStore.fromTime()">
    @switch (calendarType.value) {
      @case ('year') {
        <stch-calendar-year
          [viewDate]="date.value"
          [events]="events()"
          [selectedDate]="selectedDayInDisplayFrame"
          [scrollToDate]="calendarScrollTarget()"
          (dateClicked)="handleDayClicked($event)"
          (dateDblClicked)="openDailyView($event)"
          (eventDropped)="handleCellDrop($event)"
          (eventClicked)="openEventInModal($event)"
          />
      }
      @case ('month') {
        <stch-full-calendar-month
          [viewDate]="date.value"
          [events]="events()"
          [selectedDate]="selectedDayInDisplayFrame"
          [scrollToDate]="calendarScrollTarget()"
          (dateClicked)="handleDayClicked($event)"
          (dateDblClicked)="openDailyView($event)"
          (eventDropped)="handleCellDrop($event)"
          (eventClicked)="openEventInModal($event)"
          />
      }
      @case ('week') {
        <stch-calendar-week
          [viewDate]="date.value"
          [events]="events()"
          [calendarType]="CalendarType.WEEK"
          [scrollToDate]="calendarScrollTarget()"
          (dateClicked)="handleDynamicPopoverEventCreation($event.date, $event.originRef)"
          (dateDblClicked)="handleEventModalCreation($event)"
          (eventDropped)="handleCellDrop($event)"
          (dayNumberClicked)="scrollToDateHandler($event)"
          (dayNumberDblClicked)="openDailyView($event)"
          (eventClicked)="openEventInModal($event)"
          />
      }
      @case ('workWeek') {
        <stch-calendar-week
          [viewDate]="date.value"
          [events]="events()"
          [calendarType]="CalendarType.WORKWEEK"
          [scrollToDate]="calendarScrollTarget()"
          (dateClicked)="handleDynamicPopoverEventCreation($event.date, $event.originRef)"
          (dateDblClicked)="handleEventModalCreation($event)"
          (eventDropped)="handleCellDrop($event)"
          (dayNumberClicked)="scrollToDateHandler($event)"
          (dayNumberDblClicked)="openDailyView($event)"
          (eventClicked)="openEventInModal($event)"
          />
      }
      @case ('day') {
        <stch-calendar-day
          [viewDate]="date.value"
          [events]="events()"
          [showDayHeader]="false"
          [scrollToDate]="calendarScrollTarget()"
          (dateClicked)="handleDynamicPopoverEventCreation($event.date, $event.originRef)"
          (dateDblClicked)="handleEventModalCreation($event)"
          (eventDropped)="handleCellDrop($event)"
          (dayNumberClicked)="openDailyView($event)"
          (eventClicked)="openEventInModal($event)"
          />
      }
    }
  </div>

</div>

<ng-template #popoverFormTemplate let-calendarEvent="calendarEvent">
  <stch-event-popover-form
    [event]="calendarEvent"
    (close)="popoverClose.next()"
  />
</ng-template>
